export const USER_PASSWORD_MIN_LENGTH = 8
export const USER_PASSWORD_MAX_LENGTH = 30

export const STRING_MIN_LENGTH = 1
export const SHORTEST_STRING_MAX_LENGTH = 30
export const SHORT_STRING_MAX_LENGTH = 255
export const MEDIUM_STRING_MAX_LENGTH = 1_000
export const LONG_STRING_MAX_LENGTH = 10_000
export const TEXT_MAX_LENGTH = 100_000

// RFC 5321 caps a forward path at 256 octets, which leaves 254 for the address. `isEmail` already
// rejects anything longer; the explicit max makes the limit visible to JSON Schema and to
// `inputLengthLimits.spec.ts`.
export const EMAIL_MAX_LENGTH = 254
